export default "__VITE_ASSET__CXm92$u5__"